import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/home-landing/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/home-landing/components/ScrollIndicator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/home-landing/components/TestimonialsCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/home-landing/components/TonightsSpecialSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/NavigationBar.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/AppImage.tsx");
